var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"header"},[_c('top-bar'),_vm._v(" "),_c('logo'),_vm._v(" "),_c('top-menu',{attrs:{"categories":_vm.categories}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }